import Navbar from "@/components/site/Navbar";
import Hero from "@/components/site/Hero";
import About from "@/components/site/About";
import Leadership from "@/components/site/Leadership";
import Services from "@/components/site/Services";
import Stats from "@/components/site/Stats";
import Fleet from "@/components/site/Fleet";
import Testimonials from "@/components/site/Testimonials";
import MapSection from "@/components/site/MapSection";
import QuoteContact from "@/components/site/QuoteContact";
import Footer from "@/components/site/Footer";
import FloatingWhatsApp from "@/components/site/FloatingWhatsApp";

export default function Landing() {
  return (
    <div className="bg-white text-slate-900" data-testid="landing-page">
      <Navbar />
      <main>
        <Hero />
        <About />
        <Leadership />
        <Services />
        <Stats />
        <Fleet />
        <Testimonials />
        <MapSection />
        <QuoteContact />
      </main>
      <Footer />
      <FloatingWhatsApp />
    </div>
  );
}
